import { parseAccountsForFeature } from '@/assets/scripts/parsers/accounts'

/** returns tpa types list
@return { Array }
*/
export const getTpasTypesList = state => state.tpasTypes

/** returns Accounts Balances
@return { Array }
*/
export const getAccountsBalances = state => parseAccountsForFeature(state.accountsBalances)

/** returns Company Data
@return { Object }
*/
export const getCompanyData = state => state.companyData

/** returns Locations
@return { Array }
*/
export const getLocations = state => state.locations

/** returns Agencies Provinces
@return { Array }
*/
export const getAgenciesProvinces = state => state.agenciesProvinces

/** returns Branches
@return { Array }
*/
export const getBranches = state => state.branches

/** returns Economic Activities
@return { Array }
*/
export const getEconomicActivities = state => state.economicActivities

/** returns Authorized Operations
@return { Array }
*/
export const getAuthorizedOperations = state => state.authorizedOperations

/** returns Accepted Cards
@return { Array }
*/
export const getAcceptedCards = state => state.acceptedCards
